import { SkillForm } from "@/core/skillForms/types";
import { createInitialPetitionSkillStep2 } from "../step2";

export const createPensionInitialPetitionSkillForm: SkillForm = {
  skillId: "create_pension_initial_petition",
  title: "Petição Inicial Previdenciária",
  steps: [createInitialPetitionSkillStep2],
  lastStepSubmitButtonText: "Criar Petição Inicial",
};
